import React, { Component } from 'react';
import FormCreatePassword from '../../../Fields/FormCreatePassword.js';
import FormInput from '../../../Fields/FormInput.js';
import Loading from '../../Loading.js';
import update from 'immutability-helper';
import { postPassword, getExtranetUserInfo, postExtranetUserInfo } from '../../../Api/ExtranetActions.js'
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { isEmpty } from '../../../Utilities/JsonFunctions.js';

declare var globalSns;
declare var globalExtranet;

class ExtranetSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showValidation: false,
            txtUserPassword: ""
        };

        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeUserInfo = this.onChangeUserInfo.bind(this);
        this.savePassword = this.savePassword.bind(this);
        
        this.saveTimeOutId = null;
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getExtranetUserInfo(globalSns.languageId, (data) => {
            this.setState({
                userinfo: data
            });
        });
    }

    saveData() {
        postExtranetUserInfo(this.state.userinfo, (ok) => {
            if (ok) {
                this.setState({showSaved: true}, () => {
                    setTimeout(() => {
                        this.setState({showSaved: false});
                    }, 3000);
                });
            } else {
                this.setState({showError: true}, () => {
                    setTimeout(() => {
                        this.setState({showError: false});
                    }, 3000);
                });
            }
        });
    }

    onChangePassword(e, password, valid) {
        this.setState({
            password: password,
            passwordvalid: valid
        })
        
    }

    onChange(e) {
        this.setState({
            [e.target.id]: e.target.value
        });         
    }

    onChangeUserInfo(e) {
        var value;
        switch(e.target.type) {
            case "select-one": value = parseInt(e.target.value, 10); break;
            case "checkbox": value = e.target.checked; break;
            default: value = e.target.value;
        }

        // newDays: maxlength "999"
        if (e.target.id === "newDays" && (value.length > 3)) {
            return;
        }

        // showOpenOnly: change setting
        if (e.target.id === "showOpenOnly") {
            globalExtranet.showOpenOnly = e.target.checked;
        }

        this.setState({
            userinfo: update(this.state.userinfo, {[e.target.id]: {$set: value}})
        }, () => {
            // Saves data when there's no input for 2 seconds
            clearTimeout(this.saveTimeOutId);
            this.saveTimeOutId = setTimeout(() => {
                this.saveData();    
            }, 2000);
        });         
    }

    savePassword() {
        if (this.state.passwordvalid) {
            postPassword(this.state.txtUserPassword, this.state.password, (ok) => {
                if (ok === true) {
                    this.setState({
                        showValidation: false,
                        changererror: false,
                        showOk: true
                    });
                } else {
                    this.setState({
                        showValidation: true,
                        changererror: true,
                        showOk: false
                    });
                }
            })
        } else {
            this.setState({
                showValidation: true
            });
        }
    }

    render() {
        if (this.state.userinfo == null) {
            return (
                <Loading/>
            );
        }

        let transNewDays = getTranslation("sns.general.extranet.accountdata.newdays").split("#");

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ebadge">
                            {
                                (this.state.showError) ?
                                    <span className="ErrorLabel">{getTranslation("sns.general.error")}</span> : ""
                            }
                            {
                                (this.state.showSaved) ?
                                    <span className="SuccessLabel">{getTranslation("sns.general.saved")}</span> : ""
                            }
                            <h2>{getTranslation("sns.general.extranet.accountdata")}</h2>
                            <div className="EditingFormTable table">
                                <FormInput id="name" 
                                    text={getTranslation("sns.general.extranet.accountdata.name")}
                                    disabled={true}
                                    value={this.state.userinfo.firstName + " " + this.state.userinfo.name} />
                                <FormInput id="email" 
                                    text={getTranslation("sns.general.extranet.accountdata.email")}
                                    disabled={true}
                                    value={this.state.userinfo.email} />
                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <h2>{getTranslation("sns.general.extranet.accountdata.language")}</h2>
                                </div>
                                <div className="col-sm-1">
                                    <select id="languageId" autoComplete="no-autocomplete"
                                    className="form-control" onChange={this.onChangeUserInfo} value={this.state.userinfo.languageId}>
                                        {[1,2,3].includes(this.state.userinfo.languageId) ? "" : <option value=""></option>}
                                        <option value="1">NL</option>
                                        <option value="2">FR</option>
                                        <option value="3">EN</option>
                                    </select>                                                               
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-8">
                                    <div className="checkbox-inline">
                                        <span className="CheckBoxField checkbox">                            
                                            <input type="checkbox" id="notifyNewCandidates" onChange={this.onChangeUserInfo} checked={this.state.userinfo.notifyNewCandidates} />
                                            <label htmlFor="notifyNewCandidates">&nbsp;</label>
                                        </span>                                      
                                        <h2>{getTranslation("sns.general.extranet.accountdata.notifynewcandidates")}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-8">
                                    <div className="checkbox-inline">
                                        <span className="CheckBoxField checkbox">                            
                                            <input type="checkbox" id="notifyNewMessages" onChange={this.onChangeUserInfo} checked={this.state.userinfo.notifyNewMessages} />
                                            <label htmlFor="notifyNewMessages">&nbsp;</label>
                                        </span>                                      
                                        <h2>{getTranslation("sns.general.extranet.accountdata.notifynewmessages")}</h2>                                        
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-8">
                                    <div className="checkbox-inline">
                                        <span className="CheckBoxField checkbox">                            
                                            <input type="checkbox" id="showOpenOnly" onChange={this.onChangeUserInfo} checked={this.state.userinfo.showOpenOnly} />
                                            <label htmlFor="showOpenOnly">&nbsp;</label>
                                        </span>                                      
                                        <h2>{getTranslation("sns.general.extranet.accountdata.showopenonly")}</h2>
                                        <div className="ExplanationText">
                                            {getTranslation("sns.general.extranet.accountdata.showopenonly.info")}
                                        </div>                                        
                                    </div>
                                </div>
                            </div>                                                        
                            <div className="row">
                                <div className="col-sm-8">
                                    <h2>
                                        {transNewDays[0]}
                                        <input type="number" min="1" max="999" id="newDays" onChange={this.onChangeUserInfo} value={this.state.userinfo.newDays} />
                                        {transNewDays.length > 1 ? transNewDays[1] : ""}
                                    </h2>
                                </div>
                            </div>
                            <h2>{getTranslation("sns.general.extranet.changepassword")}</h2>
                            <div className="EditingFormTable table">
                                {
                                    (this.state.changererror) ?
                                        <span className="ErrorLabel">{getTranslation("sns.webparts.password.error")}</span> : ""
                                }
                                {
                                    (this.state.showOk) ?
                                        <span className="SuccessLabel">{getTranslation("sns.webparts.password.changed")}</span> : ""
                                }            
                                <FormInput id="txtUserPassword" 
                                    text={getTranslation("sns.webparts.password.current")}
                                    required={true}
                                    type="password"
                                    validationText={isEmpty(this.state.txtUserPassword) ? getTranslation("basicform.erroremptyvalue"): null}
                                    showValidation={this.state.showValidation}
                                    value={this.state.txtUserPassword} 
                                    onChange={this.onChange} />             
                                <FormCreatePassword 
                                    showValidation={this.state.showValidation}
                                    showLegend={false}
                                    onChange={this.onChangePassword} />
                                <div className="tr text-right col-sm-8">
                                    <input type="button" id="save"
                                        className="FormButton btn btn-primary next"
                                        value={getTranslation("sns.webparts.password.change")}
                                        onClick={this.savePassword} />                                    
                                </div>
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExtranetSettings;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetSettings.js